import { productModificationApi } from 'apiConnector/product-modification';
import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import type { ProductModificationAck, ProductModificationRequest } from 'models/forms/productModification';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';
import { productModificationApplyRequestFailed } from 'state/productModificationForm/productModificationForm.action';
import type { EpicWithThunk } from 'state/state.common';

export interface ApplyProductModificationApi {
  apply(productModificationRequest: ProductModificationRequest): Observable<ProductModificationAck>;
}
export function applyProductModificationEpic(): EpicWithThunk {
  return (
    action$,
    state$,
    { selectors: { productModificationSelectors, getDynamicFormInfos }, oldHttpClient, frontLogger },
  ) => {
    return action$.pipe(
      ofType('PRODUCT_MODIFICATION_APPLY_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ tabId }, state]) => {
        const comment = productModificationSelectors.getFightingBackComment(state, tabId)!;
        const justification = productModificationSelectors.getFightingBackJustification(state, tabId)!;
        const requestId = productModificationSelectors.getRequestId(state, tabId)!;
        const { quoteQuery, etag } = getDynamicFormInfos(state, tabId)!;
        const productId = productModificationSelectors.getProductId(state, tabId)!;

        const request: ProductModificationRequest = {
          comments: comment,
          typologyId: justification,
          requestId,
          quoteQuery,
          productId,
          etag: etag!,
        };

        return productModificationApi(oldHttpClient)
          .apply(request)
          .pipe(
            mergeMap(() => EMPTY),
            catchError(error => {
              frontLogger.error('An error occurred in applyProductModificationEpic {@FrontError}', error);
              return of(
                productModificationApplyRequestFailed(tabId, requestId, apiErrorHelper.toApiErrorMessage(error), error),
              );
            }),
          );
      }),
    );
  };
}
